// Sorted by "importance"
export enum UserCompanyType {
  SUPERVISOR = 'supervisor',
  MEMBER = 'member',
  UNKNOWN = 'unknown',
}

export const userCompanyTypeAsString = (type: UserCompanyType | string): string => {
  switch (type) {
    case UserCompanyType.SUPERVISOR:
      return "👑 Superviseur";
    case UserCompanyType.MEMBER:
      return "👤 Membre";
    case UserCompanyType.UNKNOWN:
    default:
      return "❓ Type inconnu";
  }
};

/**
 * Not supposed to be usefull because an user should'nt have more than 2 roles (supervisor + another) on the same subscription
 * This function is only a security
 * Get the "better" user type (the importance order is the order in UserType definition)
 * 
 * @param types 
 * @param ignoredTypes 
 * @returns 
 */
export const getBestUserCompanyType = (types: UserCompanyType[], ignoredTypes: UserCompanyType[] = []): UserCompanyType => {
  const userCompanyTypes = Object.values(UserCompanyType)
    .filter(type => !ignoredTypes.includes(type))
    
    for (const type of userCompanyTypes) {
      if (types.includes(type)) {
        return type;
      }
    }
    
    return UserCompanyType.UNKNOWN;
};